import { render, staticRenderFns } from "./Tabbing.vue?vue&type=template&id=2bbd6e1a&scoped=true&"
import script from "./Tabbing.vue?vue&type=script&lang=js&"
export * from "./Tabbing.vue?vue&type=script&lang=js&"
import style0 from "./Tabbing.vue?vue&type=style&index=0&id=2bbd6e1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd6e1a",
  null
  
)

export default component.exports